import React from 'react'

export const TextDisplay = ({ value }) => {
  return <span>{value ? value : '-'}</span>
}
